import React from "react";
import { Phone, Send, Instagram } from "lucide-react";
import { SITE_CONFIG, telHref, telegramLink } from "../lib/config";
import { trackCall, trackEvent } from "../lib/analytics";

export default function Footer({ lang, T }) {
  return (
    <footer className="relative border-t border-white/5 pt-12 pb-28 md:pb-12 bg-ink-900">
      <div className="mx-auto max-w-7xl px-4 md:px-6 grid md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-xl bg-gradient-to-br from-ice-400 to-ice-300 grid place-items-center">
              <span className="text-ink-900 font-black text-sm">H</span>
            </span>
            <div className="font-display font-bold tracking-tight">{SITE_CONFIG.brand}</div>
          </div>
          <p className="mt-3 text-sm text-muted leading-relaxed max-w-md">{T.footer.disclaimer[lang]}</p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-widest text-muted mb-3">{lang === "uz" ? "Kontaktlar" : "Контакты"}</div>
          <a
            href={telHref}
            onClick={() => trackCall("footer")}
            data-testid="footer-call-link"
            className="flex items-center gap-2 text-white font-semibold hover:text-ice-300 transition"
          >
            <Phone size={14} /> {SITE_CONFIG.phoneDisplay}
          </a>
          <a
            href={telegramLink}
            target="_blank" rel="noreferrer"
            onClick={() => trackEvent("ClickTelegram", { source: "footer", language: lang })}
            data-testid="footer-telegram-link"
            className="mt-3 inline-flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-bold transition hover:brightness-110 shadow-lg"
            style={{ background: "#229ED9", color: "white" }}
          >
            <Send size={14} /> {T.cta.writeTelegram[lang]}
          </a>
          <a
            href={SITE_CONFIG.instagramUrl}
            target="_blank" rel="noreferrer"
            onClick={() => trackEvent("ClickInstagram", { source: "footer", language: lang })}
            data-testid="footer-instagram-link"
            className="mt-3 flex items-center gap-2 text-sm text-muted hover:text-white transition"
          >
            <Instagram size={14} /> @havo_comfort
          </a>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-widest text-muted mb-3">{lang === "uz" ? "Geografiya" : "География"}</div>
          <div className="flex flex-wrap gap-2">
            {["Ташкент / Toshkent", "Самарканд", "Бухара", "Фергана", "Андижан", "Наманган"].map((c) => (
              <span key={c} className="text-xs text-muted bg-white/[0.03] border border-white/5 rounded-full px-3 py-1.5">
                {c}
              </span>
            ))}
          </div>
          <div className="mt-5 text-xs text-muted">{SITE_CONFIG.delivery[lang]}</div>
          <div className="mt-1 text-xs text-muted">{SITE_CONFIG.guarantee[lang]}</div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 md:px-6 mt-10 pt-6 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-xs text-muted">
        <div>{T.footer.rights[lang]}</div>
        <div>{lang === "uz" ? "Air Cooler · Mobil bug'lanadigan havo sovutgich" : "Air Cooler · Мобильный испарительный охладитель"}</div>
      </div>
    </footer>
  );
}
